/*
  CARD AUDIO — comportamento condiviso.

  Un solo file per tutte le card della pagina: le sezioni ne stampano quante
  ne vogliono, qui si occupa di farle suonare una alla volta.

  Scelte che contano:
  - <audio preload="none">: quattro file da mezzo mega non si scaricano finche'
    qualcuno non preme play. La durata quindi NON e' nota in partenza, e per
    questo la si scrive a mano nell'impostazione del blocco: senza, per il
    primo mezzo secondo si leggerebbe "0:00 / 0:00".
  - un solo audio per volta: partendo, ferma gli altri. Due voci sovrapposte
    sono il modo piu' rapido per far chiudere la pagina.
  - la barra e' un vero slider da tastiera (frecce), non un div cliccabile.
*/
(function () {
  'use strict';

  var TUTTE = [];

  function mmss(secondi) {
    if (!isFinite(secondi) || secondi < 0) secondi = 0;
    var m = Math.floor(secondi / 60);
    var s = Math.floor(secondi % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function prepara(card) {
    if (card.dataset.vxacPronta === '1') return;
    card.dataset.vxacPronta = '1';

    var audio = card.querySelector('audio');
    var play  = card.querySelector('[data-vxac-play]');
    var barra = card.querySelector('[data-vxac-barra]');
    var riemp = card.querySelector('[data-vxac-riempimento]');
    var tempo = card.querySelector('[data-vxac-tempo]');
    var nome  = (card.getAttribute('data-vxac-nome') || '').trim();
    if (!audio || !play) return;

    /* Durata dichiarata nel blocco, in secondi: serve finche' il file non e'
       stato scaricato. Appena il browser conosce quella vera, si usa quella. */
    var durata = Number(card.getAttribute('data-vxac-durata')) || 0;

    function durataViva() {
      return isFinite(audio.duration) && audio.duration > 0 ? audio.duration : durata;
    }

    function scrivi() {
      var d = durataViva();
      if (tempo) tempo.textContent = mmss(audio.currentTime) + ' / ' + mmss(d);
      var q = d > 0 ? Math.min(1, audio.currentTime / d) : 0;
      if (riemp) riemp.style.width = (q * 100).toFixed(2) + '%';
      if (barra) {
        barra.setAttribute('aria-valuenow', Math.round(q * 100));
        barra.setAttribute('aria-valuetext', mmss(audio.currentTime) + ' di ' + mmss(d));
      }
    }

    function etichetta() {
      var azione = audio.paused ? 'Ascolta' : 'Metti in pausa';
      play.setAttribute('aria-label', azione + (nome ? ' la voce di ' + nome : ' l’audio'));
      play.setAttribute('aria-pressed', audio.paused ? 'false' : 'true');
      card.classList.toggle('e-suona', !audio.paused);
    }

    play.addEventListener('click', function () {
      if (audio.paused) {
        TUTTE.forEach(function (a) { if (a !== audio && !a.paused) a.pause(); });
        var p = audio.play();
        if (p && p.catch) p.catch(function () { /* il browser puo' rifiutare: si resta in pausa */ });
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', etichetta);
    audio.addEventListener('pause', etichetta);
    audio.addEventListener('timeupdate', scrivi);
    audio.addEventListener('loadedmetadata', scrivi);
    audio.addEventListener('ended', function () { audio.currentTime = 0; scrivi(); etichetta(); });

    function vaiA(quota) {
      var d = durataViva();
      if (d > 0) { audio.currentTime = Math.max(0, Math.min(d, d * quota)); scrivi(); }
    }

    if (barra) {
      barra.addEventListener('click', function (e) {
        var r = barra.getBoundingClientRect();
        if (r.width > 0) vaiA((e.clientX - r.left) / r.width);
      });
      barra.addEventListener('keydown', function (e) {
        var d = durataViva();
        if (!d) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); vaiA((audio.currentTime + 5) / d); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); vaiA((audio.currentTime - 5) / d); }
        if (e.key === 'Home')       { e.preventDefault(); vaiA(0); }
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); play.click(); }
      });
    }

    TUTTE.push(audio);
    scrivi();
    etichetta();
  }

  function avvia() {
    [].forEach.call(document.querySelectorAll('[data-vxac]'), prepara);
  }

  if (document.readyState !== 'loading') { avvia(); }
  else { document.addEventListener('DOMContentLoaded', avvia); }

  /* Nel theme editor le sezioni vengono ricostruite: le card nuove vanno
     preparate, altrimenti il play non risponde. */
  document.addEventListener('shopify:section:load', avvia);
})();
